import React, { useState, useEffect } from "react";

import NavBar from "./NavBar";
import SideBar from "./SideBar";

import { getIsAdmin } from "../../services/userService"; // 2025-10-20

function Menu() {

  const [isAdmin, setIsAdmin] = useState(true);

  // 2025-10-20
  /* useEffect(() => {

    const token = localStorage.getItem("token");

    getIsAdmin(token)
      .then((response) => {
        console.log("RESPOSTA ISADMIN: ", response);
        if ( response.isAdmin ) {
          setIsAdmin(true);
        }
      })
      .catch((err) => {
        //if (err.response && err.response.status === 401) return navigate("/");
        // setError(err.response ? err.response.data : err.message);
      });
  }, []); */

  return (
    <>
      <NavBar />
      <SideBar isAdmin={isAdmin} />
    </>
  );
}

export default Menu;
